// Verifies if the parameter is object and if has keys. Returns TRUE if the object has data.
const isEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

// Valida al menos una de las siguientes:
// 1) el string debe tener al menos una letra
// 2) O el string iniciar con "/" (esto para validar rutas)
// Si ninguna de esas esta en el string, returna True (porque el string esta mal), de lo contrario retorna False (porque el string esta bien)
const isBadStr = txt => !/^\w+|\/[\w]+|\//gmi.test((txt).trim());

// Validates a param. Returns FALSE when value is:
//    > Null, Undefined, Empty objects, Empty Functions, Empty Arrays, Empty Strings (At least 1 letter), number: 0, False
const ValidOne = item => {
  try {
    if ( item !== null && item !== undefined && item !== false && !(item instanceof Error)){
      if ( item instanceof Object || /object|obj/gmi.test(typeof item) ) {
        if (isEmpty(item))
          return false;
      }

      if ( /Array/gim.test(Object.prototype.toString.call(item)) || item instanceof Array ) {
        if (item.length === 0)
            return false;
      }

      if ( item instanceof Set || /Set/gim.test(Object.prototype.toString.call(item)) ) {
        if (item.size === 0)
            return false;
      }

      if (typeof item === "string" || /string/gmi.test(typeof item)) {
        if ( isBadStr(item) )
          return false;
      }

      if (!isNaN(item)){
        if (item === 0)
          return false;
      }

      if (typeof item === "function" || /funct/gmi.test(typeof item)) {
        if ( item.toString().includes("{}") )
          return false;
      }

      return true;

    }
    else
      return false;

  } catch (e) { return false; }
}

// Verifies a group of at least 1 param. Returns True if they all are ok
const _valid = (...args) => ValidOne([...args]) && [...args].every(it => ValidOne(it));

export default _valid